'use client';

import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';

import type { SlotProps } from '../Base/Slot.client';
import { Slot } from '../Base/Slot.client';
import { useBasketLink } from '../../shared/useBasketLink';

/** Cart slot */
export const BasketSlot = (props: Pick<SlotProps, 'priority'>) => {
  const { language } = useI18n();
  const { href, label, badgeCount } = useBasketLink();

  return (
    <Slot
      {...props}
      language={language}
      icon={<span className="icon-emp-cart size-4" />}
      linkAriaLabel={label}
      href={href}
      badgeCount={badgeCount}
      title={label}
      className="xl:min-w-4.5"
    />
  );
};
